<template>
  <component :is="tagName" class="ushk-star"><i class="ushk-star_active" :class="{'ushk-star_important': width > 2}" :style="{width: `${width * 20}%`}"></i></component>
</template>
<script>
  export default {
    props: {
      width: [String, Number],
      tagName: {
        type: String,
        default: 'div'
      }
    }
  }
</script>


// WEBPACK FOOTER //
// Star.vue?254b6a1d